<template>
    <path d="M10.43 19.95c-.1-.07-.66-1.18-1.25-2.46A33.24 33.24 0 0 0 8 15.03c-.06-.06-1.35-.44-2.86-.84l-2.92-.78c-.23-.06-.32-.35-.16-.5.19-.2 19.47-8.99 19.69-8.99.49 0 .49 0-.97 6.98-.76 3.68-1.43 6.75-1.5 6.82-.15.2-.3.17-2.73-.48l-2.27-.61-1.73 1.72c-.95.95-1.77 1.73-1.83 1.73a.65.65 0 0 1-.28-.13zm.28-3.44l.18-1.18.93-1c.51-.57 2.05-2.23 3.42-3.7a55.92 55.92 0 0 0 2.34-2.6c-.14.08-8.35 6.47-8.58 6.67-.05.05.24.8.66 1.72.52 1.13.76 1.58.8 1.45.04-.1.15-.7.25-1.36z"/>
</template>

<script>
    export default {
        name: 'send',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Send.vue